module.exports = __webpack_public_path__ + "static/DisabledDamagedLostItem-b87dcd4844158601d6ded699d6fa4ea0.png";